import TaggingPlanApiClient from "~/apiClients/TaggingPlanApiClient";
import DateHelper from "~/helpers/DateHelper";

export interface TaggingPlanAttributes {
  id: number,
  name: string,
  version: number,
  status: number,
  createdAt: string,
  isDeleted?: boolean,
  updatedAt?: string,
  updatedBy?: string,
}

export interface TaggingPlanCreationAttributes {
  name: string;
  status?: number;
  version?: number;
}

export interface TaggingPlanUpdateAttributes {
  name: string;
}

export enum TaggingPlanStatus {
  DRAFT = 0,
  PUBLISHED = 1,
  ARCHIVED = 2,
}

export class TaggingPlan {
  constructor(private readonly attributes: TaggingPlanAttributes) {
  }
  get id(): number {
    return this.attributes.id;
  }

  get name(): string {
    return this.attributes.name;
  }

  get version(): number {
    return this.attributes.version;
  }

  get status(): number {
    return this.attributes.status;
  }

  get isDeleted(): boolean {
    return this.attributes.isDeleted;
  }

  get lastModified(): string {
    return DateHelper.format(this.attributes.updatedAt ?? this.attributes.createdAt);
  }

  static async findAll() {
    return await this.getApiClient().provideList();
  }

  static async findById(id: number) {
    return await this.getApiClient().provideById(id);
  }

  static async create(attributes: TaggingPlanCreationAttributes) {
    attributes.status = TaggingPlanStatus.DRAFT;
    attributes.version = 1;
    return await this.getApiClient().create(attributes);
  }

  async update(attributes: TaggingPlanUpdateAttributes): Promise<TaggingPlan> {
    return await TaggingPlan.getApiClient().update(attributes);
  }

  static async delete(id: number) {
    return await this.getApiClient().delete(id);
  }

  static async createDraftVersion(id: number) {
    return await this.getApiClient().createDraftVersion(id);
  }

  private static getApiClient(): TaggingPlanApiClient {
    return new TaggingPlanApiClient();
  }
}
